import { useEffect } from 'react';
import { resumePendingReportTasks } from '../../utils/reportTaskTracker';

/** Resumes polling for in-progress background report tasks (survives route changes). */
export default function BackgroundReportTaskPoller() {
  useEffect(() => {
    resumePendingReportTasks();
  }, []);

  return null;
}
